
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wjgmprdxfqqdplujwusr.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndqZ21wcmR4ZnFxZHBsdWp3dXNyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk0MjAwMTUsImV4cCI6MjA1NDk5NjAxNX0.or7huUqyCDKEz8AkW8gGnZNR0H2Bk_Yu_PJ1vsRgRVE'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    detectSessionInUrl: true,
    autoRefreshToken: true,
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    flowType: 'pkce'
  }
})
